import { useTranslation } from 'next-i18next';

import { useEffect, useRef } from 'react';

import { mapToaster } from '@nocowanie/common-ui/components/molecules/toaster';

import { MarkerDataType } from '@app/models';

const commonMapToastConfig = {
    placement: 'bottom',
};

export function useMapToasts({
    accommodations,
    isLoadingAccommodations,
    accommodationsError,
    isMobileRes,
    isFiltersContentVisible,
}: {
    accommodations?: MarkerDataType[];
    isLoadingAccommodations: boolean;
    accommodationsError: string | null;
    isMobileRes?: boolean;
    isFiltersContentVisible?: boolean;
}) {
    const { t } = useTranslation('common', { keyPrefix: 'errors' });
    const hasShownEmptyToast = useRef(false);
    const hasShownErrorToast = useRef(false);
    const prevLoadingState = useRef(isLoadingAccommodations);

    useEffect(() => {
        if (isLoadingAccommodations && !prevLoadingState.current) {
            setTimeout(() => mapToaster.dismiss(), 0);
            hasShownEmptyToast.current = false;
            hasShownErrorToast.current = false;
        }
        prevLoadingState.current = isLoadingAccommodations;
    }, [isLoadingAccommodations]);

    useEffect(() => {
        if (accommodationsError && !isLoadingAccommodations && !hasShownErrorToast.current) {
            setTimeout(() => {
                const toastId = mapToaster.create({
                    ...commonMapToastConfig,
                    description: t('searchAccommodationsError'),
                });
                mapToaster.pause(toastId);
            }, 0);
            hasShownErrorToast.current = true;
        }
    }, [accommodationsError, isLoadingAccommodations, t]);

    useEffect(() => {
        if (
            !accommodationsError &&
            !isLoadingAccommodations &&
            accommodations &&
            accommodations.length === 0 &&
            !hasShownEmptyToast.current
        ) {
            setTimeout(() => {
                const toastId = mapToaster.create({
                    ...commonMapToastConfig,
                    description: t('noAccommodationsFound'),
                });
                mapToaster.pause(toastId);
            }, 0);
            hasShownEmptyToast.current = true;
        }
    }, [accommodations, isLoadingAccommodations, accommodationsError, t]);

    useEffect(() => {
        if (isMobileRes && isFiltersContentVisible) {
            setTimeout(() => {
                mapToaster.dismiss();
            }, 0);
        }
    }, [isMobileRes, isFiltersContentVisible]);
}
